// Cookie consent for Google Analytics (EU / GDPR): Analytics is only loaded after the visitor accepts.

export const GA_ID = 'G-BJLW1M5QG2';
const STORAGE_KEY = 'cookie-consent';

export type Consent = 'granted' | 'denied';

export const getConsent = (): Consent | null => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch {
    return null;
  }
};

export const saveConsent = (value: Consent) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage blocked: the choice applies to this visit only.
  }
  if (value === 'granted') loadAnalytics();
};

let loaded = false;

export const loadAnalytics = () => {
  if (loaded) return;
  loaded = true;

  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    w.dataLayer.push(arguments);
  };
  w.gtag('js', new Date());
  w.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};
